import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const InsuranceRoutes: BaseRoute[] = [
  {
    path: '*',
    title: 'All',
    name: 'product.insurance.tabs.all',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-all')),
    hideFromMainMenu: true,
    isActive: true,
    icon: 'icon-list',
  },
  {
    path: 'hardware',
    title: 'Hardware',
    name: 'product.insurance.tabs.hardware',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-hardware')),
    hideFromMainMenu: true,
    icon: 'icon-decoder-care-contract',
  },
  {
    path: 'funeral-policy',
    title: 'Funeral Policy',
    name: 'product.insurance.tabs.funeral',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-funeral')),
    hideFromMainMenu: true,
    icon: 'icon-family-funeral',
  },
  {
    path: 'subscription-waiver',
    title: 'Subscription Waiver',
    name: 'product.insurance.tabs.subscription',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-subscription-waiver')),
    hideFromMainMenu: true,
    icon: 'icon-tv',
  },
  {
    path: 'debt-waiver',
    title: 'Debt Waiver',
    name: 'product.insurance.tabs.debt',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-debt-waiver')),
    hideFromMainMenu: true,
    icon: 'icon-debt-waiver',
  },
  {
    path: 'policy-comms',
    title: 'Policy Comms',
    name: 'product.insurance.tabs.policyComms',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/insurance-policy-comms')),
    hideFromMainMenu: true,
    icon: 'icon-announcement',
  },
];